// Contenu bilingue FR/EN du site INEXPONENS
export const COMPANY = {
  name: "INEXPONENS",
  fullName: "INEXPONENS AUDIT & ADVISORY",
  phone: "+224 613 47 39 08",
  phoneRaw: "+224613473908",
  email: "contact@inexponens.com",
  address: "Rue 366, Quartier Kaporo Cité, Commune de Ratoma — Conakry (République de Guinée)",
  addressEn: "Rue 366, Kaporo Cité, Ratoma — Conakry (Republic of Guinea)",
  city: "Conakry",
  website: "www.inexponens.com",
  logo: "https://customer-assets-jt897jd0.emergentagent.net/job_fec190a4-e903-452d-8ea9-b8c5ebb46e4d/artifacts/es06wxo2_LOGO%20V1.png",
};

const FOUNDER_SHARED = {
  name: "Cellou DIALLO",
  photo: "https://customer-assets-jt897jd0.emergentagent.net/job_fec190a4-e903-452d-8ea9-b8c5ebb46e4d/artifacts/if9nfp6r_WhatsApp%20Image%202026-06-07%20at%2023.42.33.jpeg",
};

const IMAGES = {
  hero1: "https://images.unsplash.com/photo-1443527394413-4b820fd08dde?w=1920&q=80",
  heroConakry: "https://upload.wikimedia.org/wikipedia/commons/thumb/5/51/Ville_de_Conaky.jpg/1920px-Ville_de_Conaky.jpg",
  hero3: "https://images.unsplash.com/photo-1534237710431-e2fc698436d0?w=1920&q=80",
  valueExperts: "https://images.pexels.com/photos/8276185/pexels-photo-8276185.jpeg?w=800&q=80",
  valueIndep: "https://images.pexels.com/photos/8730178/pexels-photo-8730178.jpeg?w=800&q=80",
  valueTrust: "https://images.unsplash.com/photo-1739298061740-5ed03045b280?w=800&q=80",
  svcAudit: "https://images.pexels.com/photos/7693692/pexels-photo-7693692.jpeg?w=1000&q=80",
  svcAdvisory: "https://images.pexels.com/photos/7841502/pexels-photo-7841502.jpeg?w=1000&q=80",
  svcCompta: "https://images.pexels.com/photos/8297145/pexels-photo-8297145.jpeg?w=1000&q=80",
  svcFormation: "https://images.pexels.com/photos/8730848/pexels-photo-8730848.jpeg?w=1000&q=80",
  secCommerce: "https://images.pexels.com/photos/27452443/pexels-photo-27452443.jpeg?w=800&q=80",
  secIndustrie: "https://images.unsplash.com/photo-1496247749665-49cf5b1022e9?w=800&q=80",
  secBanque: "https://images.unsplash.com/photo-1633158829585-23ba8f7c8caf?w=800&q=80",
  secTelecom: "https://images.unsplash.com/photo-1767884162181-68267b807b40?w=800&q=80",
  secOng: "https://images.unsplash.com/photo-1488521787991-ed7bbaae773c?w=800&q=80",
  secBtp: "https://images.pexels.com/photos/3818947/pexels-photo-3818947.jpeg?w=800&q=80",
  teamHero: "https://images.pexels.com/photos/1181370/pexels-photo-1181370.jpeg?w=1920&q=80",
};

export { IMAGES };

const CONTENT = {
  fr: {
    heroSlides: [
      { id: 1, image: IMAGES.hero1, line1: "L'intelligence financière", line2: "au service de vos ambitions" },
      { id: 2, image: IMAGES.heroConakry, line1: "Audit, conseil & expertise", line2: "comptable à Conakry" },
      { id: 3, image: IMAGES.hero3, line1: "Un partenaire engagé", line2: "dans votre réussite" },
    ],
    values: [
      { id: 1, title: "Nos experts", image: IMAGES.valueExperts, text: "Notre équipe impliquée est composée de collaborateurs, comptables, juristes, auditeurs et experts paie qui sont à votre écoute pour vous accompagner, conseiller et vous aider à construire et développer votre entreprise." },
      { id: 2, title: "Indépendance", image: IMAGES.valueIndep, text: "INEXPONENS est un cabinet d'expertise comptable indépendant de tout réseau. Nous garantissons à nos clients des avis et conseils impartiaux, en toute objectivité et transparence." },
      { id: 3, title: "Confiance", image: IMAGES.valueTrust, text: "Nous sommes pleinement impliqués dans la relation que nous construisons ensemble sur le long terme. Disponibilité, confiance, rigueur et qualité du conseil sont au cœur de notre engagement." },
    ],
    services: [
      { id: "audit", title: "Audit", image: IMAGES.svcAudit, short: "Nos missions d'audit légal, contractuel ou interne visent à garantir la fiabilité des informations financières, à évaluer le contrôle interne et à assurer la conformité réglementaire.", details: ["Commissariat aux comptes et audit légal", "Audit contractuel et due diligence", "Évaluation du contrôle interne et des risques", "Audit de conformité fiscale, sociale et réglementaire", "Fiabilisation de l'information financière", "Audit de projets et de subventions"] },
      { id: "advisory", title: "Advisory", image: IMAGES.svcAdvisory, short: "De la conformité à la performance, nous vous guidons à chaque étape de votre développement : création, structuration, gestion, croissance, pilotage et optimisation.", details: ["Accompagnement à la création et structuration d'entreprise", "Conseil stratégique et pilotage de la performance", "Restructuration, fusions & acquisitions", "Analyse financière et évaluation d'entreprise", "Digitalisation des processus financiers", "Assistance aux dirigeants et gouvernance"] },
      { id: "expertise-comptable", title: "Expertise comptable", image: IMAGES.svcCompta, short: "Nous assurons la tenue comptable, la préparation des situations intermédiaires et l'établissement des états financiers, garantissant la fiabilité et la conformité des comptes.", details: ["Tenue et supervision comptable (SYSCOHADA / IFRS)", "Établissement des états financiers annuels", "Situations comptables intermédiaires", "Déclarations fiscales et sociales", "Gestion de la paie et des obligations sociales", "Externalisation de la fonction comptable"] },
      { id: "formations", title: "Formations", image: IMAGES.svcFormation, short: "Nous concevons des formations pratiques et sur mesure en comptabilité, fiscalité, audit et gestion pour renforcer les compétences de vos équipes.", details: ["Formations en comptabilité SYSCOHADA", "Fiscalité des entreprises en Guinée", "Audit interne et contrôle de gestion", "Gestion de la paie et droit social", "Pilotage financier pour dirigeants", "Ateliers pratiques et études de cas"] },
    ],
    sectors: [
      { id: 1, title: "Commerce & Distribution", image: IMAGES.secCommerce, text: "Gestion des stocks, marges et flux de trésorerie : nous accompagnons les acteurs du négoce et de la distribution dans le pilotage quotidien de leur activité." },
      { id: 2, title: "Industrie & Mines", image: IMAGES.secIndustrie, text: "Comptabilité analytique, conventions minières et reporting : une expertise adaptée aux exigences des industries et du secteur extractif guinéen." },
      { id: 3, title: "Banque & Finance", image: IMAGES.secBanque, text: "Audit réglementaire, contrôle interne et conformité : nous répondons aux normes strictes des établissements financiers et de microfinance." },
      { id: 4, title: "Télécoms & Technologies", image: IMAGES.secTelecom, text: "Des modèles économiques innovants nécessitent un conseil agile : revenue assurance, fiscalité spécifique et accompagnement de la croissance." },
      { id: 5, title: "ONG & Institutions", image: IMAGES.secOng, text: "Audit de projets, gestion de subventions et reporting bailleurs : une maîtrise complète des exigences des organisations à but non lucratif." },
      { id: 6, title: "BTP & Immobilier", image: IMAGES.secBtp, text: "Suivi des chantiers, comptabilité à l'avancement et gestion des marchés : un accompagnement dédié aux entreprises de construction." },
    ],
    founder: {
      ...FOUNDER_SHARED,
      role: "Expert-comptable & Commissaire aux comptes",
      heading: "Bien plus qu'un professionnel du chiffre, un véritable partenaire",
      intro: "Cellou DIALLO met son expérience et son expertise au service des entrepreneurs et des dirigeants d'entreprise, avec une conviction forte : l'expert-comptable doit être bien plus qu'un professionnel du chiffre ; il doit être un véritable partenaire du développement de l'entreprise.",
      bio: [
        "Diplômé d'expertise comptable et de commissariat aux comptes, il bénéficie d'une expérience riche et diversifiée dans les métiers de l'expertise comptable, de l'audit et du conseil.",
        "Il débute sa carrière en 2012 chez ARENES Conseil, où il acquiert les fondamentaux du métier et développe ses premières compétences en expertise comptable et en audit. En 2015, il rejoint le Cabinet HEUSSE à Issy-les-Moulineaux, où il poursuit son parcours professionnel et renforce son expertise dans l'accompagnement des entreprises, l'audit et le conseil aux dirigeants.",
        "Son expérience en tant qu'auditeur lui a permis de développer une approche particulièrement rigoureuse de l'analyse financière, du contrôle interne, de l'évaluation des risques et de la fiabilité de l'information financière. Cette double compétence en expertise comptable et en audit lui confère une vision globale de l'entreprise et une compréhension approfondie de ses enjeux financiers, comptables et organisationnels.",
        "La création de INEXPONENS traduit son ambition de construire une structure moderne, réactive et proche de ses clients, associant expertise technique, qualité de service, digitalisation et conseil à forte valeur ajoutée.",
        "Son approche repose sur une connaissance approfondie des problématiques rencontrées par les entrepreneurs et sur un accompagnement personnalisé à chaque étape de leur développement : création, structuration, gestion, croissance, pilotage et optimisation.",
        "Au quotidien, Cellou DIALLO place la disponibilité, la confiance, la rigueur et la qualité du conseil au cœur de la relation client, avec une ambition : donner aux dirigeants une vision claire de leur activité afin de sécuriser leurs décisions et de contribuer durablement à la réussite de leurs projets.",
      ],
    },
    teamRoles: [
      { id: 1, title: "Comptables", text: "Tenue, révision et production des comptes dans le respect des normes en vigueur." },
      { id: 2, title: "Auditeurs", text: "Contrôle, évaluation des risques et fiabilisation de votre information financière." },
      { id: 3, title: "Juristes", text: "Sécurisation juridique de vos opérations et de la vie de votre société." },
      { id: 4, title: "Experts paie", text: "Gestion complète de la paie et de vos obligations sociales." },
    ],
    testimonials: [
      { id: 1, name: "Mamadou B.", company: "Dirigeant, société de distribution", text: "Un cabinet très réactif et à la hauteur de nos besoins. Une équipe professionnelle sur laquelle on peut compter à tout moment." },
      { id: 2, name: "Aïssatou C.", company: "Directrice financière, secteur industriel", text: "Accompagnement impeccable, société structurée très rapidement et dans les meilleures conditions. Personnel très qualifié et disponible." },
      { id: 3, name: "Ibrahima S.", company: "Fondateur, startup technologique", text: "Des conseils clairs et un vrai partenariat. INEXPONENS nous donne une vision précise de notre activité pour sécuriser nos décisions." },
    ],
    stats: [
      { id: 1, value: "13+", label: "Années d'expérience" },
      { id: 2, value: "4", label: "Domaines d'expertise" },
      { id: 3, value: "100%", label: "Indépendance" },
      { id: 4, value: "1", label: "Interlocuteur dédié" },
    ],
  },

  en: {
    heroSlides: [
      { id: 1, image: IMAGES.hero1, line1: "Financial intelligence", line2: "serving your ambitions" },
      { id: 2, image: IMAGES.heroConakry, line1: "Audit, advisory & accounting", line2: "expertise in Conakry" },
      { id: 3, image: IMAGES.hero3, line1: "A committed partner", line2: "in your success" },
    ],
    values: [
      { id: 1, title: "Our experts", image: IMAGES.valueExperts, text: "Our dedicated team of associates, accountants, legal advisors, auditors and payroll experts is at your service to support, advise and help you build and grow your business." },
      { id: 2, title: "Independence", image: IMAGES.valueIndep, text: "INEXPONENS is an accounting firm independent from any network. We guarantee our clients impartial opinions and advice, with complete objectivity and transparency." },
      { id: 3, title: "Trust", image: IMAGES.valueTrust, text: "We are fully committed to the long-term relationship we build together. Availability, trust, rigour and quality of advice are at the heart of our commitment." },
    ],
    services: [
      { id: "audit", title: "Audit", image: IMAGES.svcAudit, short: "Our statutory, contractual and internal audit engagements aim to guarantee the reliability of financial information, assess internal control and ensure regulatory compliance.", details: ["Statutory audit and legal auditing", "Contractual audit and due diligence", "Internal control and risk assessment", "Tax, social and regulatory compliance audit", "Reliability of financial information", "Project and grant audits"] },
      { id: "advisory", title: "Advisory", image: IMAGES.svcAdvisory, short: "From compliance to performance, we guide you at every stage of your development: creation, structuring, management, growth, steering and optimisation.", details: ["Business creation and structuring support", "Strategic advisory and performance management", "Restructuring, mergers & acquisitions", "Financial analysis and business valuation", "Digitalisation of financial processes", "Executive assistance and governance"] },
      { id: "expertise-comptable", title: "Accounting", image: IMAGES.svcCompta, short: "We handle bookkeeping, interim financial statements and annual accounts preparation, ensuring the reliability and compliance of your financial records.", details: ["Bookkeeping and accounting supervision (SYSCOHADA / IFRS)", "Preparation of annual financial statements", "Interim financial reporting", "Tax and social declarations", "Payroll and social obligations management", "Outsourcing of the accounting function"] },
      { id: "formations", title: "Training", image: IMAGES.svcFormation, short: "We design practical, tailor-made training courses in accounting, taxation, audit and management to strengthen your teams' skills.", details: ["SYSCOHADA accounting training", "Corporate taxation in Guinea", "Internal audit and management control", "Payroll management and labour law", "Financial management for executives", "Practical workshops and case studies"] },
    ],
    sectors: [
      { id: 1, title: "Trade & Distribution", image: IMAGES.secCommerce, text: "Inventory, margin and cash-flow management: we support trading and distribution companies in the daily management of their business." },
      { id: 2, title: "Industry & Mining", image: IMAGES.secIndustrie, text: "Cost accounting, mining agreements and reporting: expertise tailored to the requirements of Guinea's industrial and extractive sectors." },
      { id: 3, title: "Banking & Finance", image: IMAGES.secBanque, text: "Regulatory audit, internal control and compliance: we meet the strict standards of financial and microfinance institutions." },
      { id: 4, title: "Telecoms & Technology", image: IMAGES.secTelecom, text: "Innovative business models require agile advice: revenue assurance, specific taxation and growth support." },
      { id: 5, title: "NGOs & Institutions", image: IMAGES.secOng, text: "Project audits, grant management and donor reporting: complete command of the requirements of non-profit organisations." },
      { id: 6, title: "Construction & Real Estate", image: IMAGES.secBtp, text: "Site monitoring, percentage-of-completion accounting and contract management: dedicated support for construction companies." },
    ],
    founder: {
      ...FOUNDER_SHARED,
      role: "Chartered Accountant & Statutory Auditor",
      heading: "Much more than a numbers professional — a true partner",
      intro: "Cellou DIALLO puts his experience and expertise at the service of entrepreneurs and business leaders, with a strong conviction: the accountant must be much more than a numbers professional; he must be a true partner in the company's development.",
      bio: [
        "A qualified chartered accountant and statutory auditor, he has rich and diverse experience in accounting, audit and advisory services.",
        "He began his career in 2012 at ARENES Conseil, where he acquired the fundamentals of the profession and developed his first skills in accounting and auditing. In 2015, he joined Cabinet HEUSSE in Issy-les-Moulineaux, where he continued his professional career and strengthened his expertise in business support, audit and executive advisory.",
        "His experience as an auditor has enabled him to develop a particularly rigorous approach to financial analysis, internal control, risk assessment and the reliability of financial information. This dual expertise in accounting and auditing gives him a global vision of the company and a deep understanding of its financial, accounting and organisational challenges.",
        "The creation of INEXPONENS reflects his ambition to build a modern, responsive firm close to its clients, combining technical expertise, quality of service, digitalisation and high value-added advice.",
        "His approach is based on in-depth knowledge of the challenges faced by entrepreneurs and on personalised support at every stage of their development: creation, structuring, management, growth, steering and optimisation.",
        "On a daily basis, Cellou DIALLO places availability, trust, rigour and quality of advice at the heart of the client relationship, with one ambition: to give business leaders a clear vision of their activity in order to secure their decisions and contribute sustainably to the success of their projects.",
      ],
    },
    teamRoles: [
      { id: 1, title: "Accountants", text: "Bookkeeping, review and production of accounts in compliance with current standards." },
      { id: 2, title: "Auditors", text: "Control, risk assessment and reliability of your financial information." },
      { id: 3, title: "Legal advisors", text: "Legal security for your operations and your company's corporate life." },
      { id: 4, title: "Payroll experts", text: "Complete management of payroll and your social obligations." },
    ],
    testimonials: [
      { id: 1, name: "Mamadou B.", company: "CEO, distribution company", text: "A very responsive firm that meets all our needs. A professional team you can count on at any time." },
      { id: 2, name: "Aïssatou C.", company: "CFO, industrial sector", text: "Impeccable support, company structured very quickly and under the best conditions. Highly qualified and available staff." },
      { id: 3, name: "Ibrahima S.", company: "Founder, tech startup", text: "Clear advice and a real partnership. INEXPONENS gives us a precise vision of our business to secure our decisions." },
    ],
    stats: [
      { id: 1, value: "13+", label: "Years of experience" },
      { id: 2, value: "4", label: "Areas of expertise" },
      { id: 3, value: "100%", label: "Independence" },
      { id: 4, value: "1", label: "Dedicated contact" },
    ],
  },
};

export const getContent = (lang) => CONTENT[lang] || CONTENT.fr;

export const UI = {
  fr: {
    nav: [
      { to: "/", label: "Accueil" },
      { to: "/services", label: "Nos services" },
      { to: "/secteurs", label: "Votre secteur d'activité" },
      { to: "/equipe", label: "Notre équipe" },
      { to: "/actualites", label: "Actualités" },
      { to: "/carrieres", label: "Carrières" },
      { to: "/contact", label: "Contact" },
    ],
    rdvBtn: "Rendez-vous",
    rdvBtnMobile: "Prendre rendez-vous",
    brochure: "Télécharger notre plaquette",
    contactUs: "Contactez-nous",
    requestRdv: "Demandez un rendez-vous",
    footerDesc: "Cabinet d'expertise comptable indépendant de tout réseau, pleinement impliqué dans la relation que nous construisons ensemble sur le long terme.",
    footerServices: "Nos services",
    footerCabinet: "Le cabinet",
    footerContact: "Contact",
    footerHours: "Lun – Ven : 8h30 – 17h30",
    footerRights: "Tous droits réservés",
    home: {
      cabinetTitle: "Le cabinet d'expertise comptable",
      cabinetP1a: " est un cabinet d'expertise comptable indépendant de tout réseau, basé à Conakry. Nous garantissons à nos clients des avis et conseils impartiaux et nous sommes pleinement impliqués dans la relation que nous construisons ensemble sur le long terme.",
      cabinetP2: "Le cabinet fournit à ses clients en Guinée et à l'étranger une large gamme de services : de l'expertise comptable et la tenue de comptes, à l'audit et au commissariat aux comptes, en passant par le conseil stratégique et la formation. Nous vous accompagnons dès la création de votre entreprise et à chaque étape de son développement.",
      valuesTitle: "Qui sommes-nous ?",
      servicesTitle: "Nos services",
      servicesSubtitle: "Des services d'audit et de conseil adaptés à vos besoins.",
      discoverSolutions: "Découvrir nos solutions",
      founderLabel: "L'associé",
      discoverTeam: "Découvrir notre équipe",
      testimonialsTitle: "Les avis de nos clients",
      newsTitle: "Actualités & Conseils",
      newsSubtitle: "Conseils fiscaux, nouveautés comptables et actualités du cabinet.",
      allNews: "Voir toutes nos actualités",
      readMore: "Lire plus",
      ctaTitle: "Donnons ensemble une vision claire à votre activité",
      ctaText: "Sécurisez vos décisions et contribuez durablement à la réussite de vos projets avec un partenaire de confiance à Conakry.",
    },
    servicesPage: {
      title: "Nos services",
      subtitle: "Des services d'audit, de conseil, d'expertise comptable et de formation adaptés à vos besoins.",
      serviceLabel: "Service",
      ctaTitle: "Un besoin spécifique ? Parlons-en.",
      ctaText: "Chaque mission commence par une écoute attentive de vos enjeux.",
    },
    sectorsPage: {
      title: "Votre secteur d'activité",
      subtitle: "Une connaissance approfondie des problématiques propres à chaque secteur pour un accompagnement pertinent.",
      sectionTitle: "Des expertises sectorielles",
      sectionText: "Quel que soit votre domaine, notre équipe adapte ses méthodes et ses conseils aux spécificités de votre métier.",
      ctaTitle: "Votre secteur n'est pas listé ?",
      ctaText: "Notre approche s'adapte à toutes les activités. Contactez-nous pour échanger sur vos enjeux.",
    },
    teamPage: {
      title: "Notre équipe",
      subtitle: "Des collaborateurs, comptables, juristes, auditeurs et experts paie à votre écoute.",
      sectionTitle: "Une équipe impliquée",
      teamText1: "Notre équipe impliquée est composée de collaborateurs, comptables, juristes, auditeurs et experts paie qui sont à votre écoute pour vous accompagner, conseiller et vous aider à construire et développer votre entreprise. ",
      teamText2: " est un cabinet d'expertise comptable indépendant de tout réseau : nous garantissons à nos clients des avis et conseils impartiaux, et nous sommes pleinement impliqués dans la relation que nous construisons ensemble sur le long terme.",
      founderLabel: "L'associé",
      ctaTitle: "Rencontrons-nous à Conakry",
      ctaText: "Un premier échange sans engagement pour comprendre vos besoins.",
    },
    contactPage: {
      title: "Contactez-nous",
      subtitle: "Notre équipe est à votre écoute pour répondre à toutes vos questions.",
      coordsLabel: "Nos coordonnées",
      coordsTitle: "Parlons de vos projets",
      address: "Adresse",
      phone: "Téléphone",
      email: "Email",
      hours: "Horaires",
      hoursValue: "Lundi – Vendredi : 8h30 – 17h30",
      formTitle: "Envoyez-nous un message",
      name: "Nom complet *",
      namePh: "Votre nom",
      emailField: "Email *",
      emailPh: "vous@entreprise.com",
      phoneField: "Téléphone",
      subject: "Objet de votre demande",
      subjectPh: "Sélectionnez un service",
      other: "Autre demande",
      message: "Message *",
      messagePh: "Décrivez votre besoin...",
      send: "Envoyer le message",
      sending: "Envoi en cours...",
      successToast: "Votre message a bien été envoyé. Nous vous répondrons dans les plus brefs délais.",
      errorToast: "Une erreur est survenue lors de l'envoi. Vérifiez votre adresse email et réessayez.",
      requiredToast: "Veuillez remplir les champs obligatoires (nom, email, message).",
    },
    rdvPage: {
      title: "Prendre rendez-vous",
      subtitle: "Réservez un créneau avec notre équipe en quelques clics — du lundi au vendredi.",
      step1: "1. Choisissez une date",
      step2: "2. Choisissez un créneau",
      step3: "3. Vos informations",
      selectDateFirst: "Sélectionnez d'abord une date ci-dessus.",
      loadingSlots: "Chargement des créneaux...",
      name: "Nom complet *",
      namePh: "Votre nom",
      email: "Email *",
      emailPh: "vous@entreprise.com",
      phone: "Téléphone",
      service: "Service concerné *",
      servicePh: "Sélectionnez un service",
      other: "Autre demande",
      notes: "Précisions (optionnel)",
      notesPh: "Décrivez brièvement votre besoin...",
      recap: "Récapitulatif :",
      at: "à",
      submit: "Confirmer la demande",
      sending: "Envoi en cours...",
      successToast: "Votre demande de rendez-vous a bien été enregistrée !",
      errorToast: "Une erreur est survenue. Veuillez réessayer.",
      requiredName: "Veuillez renseigner votre nom et votre email.",
      requiredService: "Veuillez sélectionner un service.",
      requiredSlot: "Veuillez choisir une date et un créneau horaire.",
      slotsError: "Impossible de charger les créneaux pour cette date.",
      confirmedTitle: "Demande enregistrée !",
      confirmedText1: "Votre demande de rendez-vous pour le service",
      confirmedText2: "le",
      confirmedText3: "à",
      confirmedText4: "a bien été transmise à notre équipe. Nous vous confirmerons ce créneau par email ou téléphone dans les plus brefs délais.",
      newRdv: "Prendre un autre rendez-vous",
    },
    newsPage: {
      title: "Actualités & Conseils",
      subtitle: "Conseils fiscaux, nouveautés comptables et actualités pour les entreprises en Guinée.",
      readMore: "Lire plus",
      empty: "Aucun article publié pour le moment.",
      back: "Retour aux actualités",
      publishedOn: "Publié le",
    },
    careersPage: {
      title: "Carrières",
      subtitle: "Rejoignez une équipe engagée au service des entreprises guinéennes.",
      sectionTitle: "Rejoignez notre équipe",
      sectionText: "INEXPONENS recherche des talents passionnés par les métiers du chiffre et du conseil : comptables, auditeurs, juristes et experts paie. Nous offrons un environnement de travail moderne, formateur et stimulant, au cœur du développement économique de la Guinée. Envoyez-nous votre candidature spontanée !",
      formTitle: "Déposez votre candidature",
      name: "Nom complet *",
      namePh: "Votre nom",
      email: "Email *",
      emailPh: "vous@email.com",
      phone: "Téléphone",
      position: "Poste souhaité *",
      positionPh: "Sélectionnez un poste",
      positions: ["Comptable", "Auditeur", "Juriste", "Expert paie", "Stagiaire", "Autre"],
      message: "Message de motivation",
      messagePh: "Présentez-vous en quelques lignes...",
      cv: "Votre CV (PDF, DOC ou DOCX — 5 Mo max)",
      cvBtn: "Choisir un fichier",
      cvNone: "Aucun fichier sélectionné",
      submit: "Envoyer ma candidature",
      sending: "Envoi en cours...",
      successToast: "Votre candidature a bien été envoyée. Nous l'étudierons avec attention !",
      errorToast: "Une erreur est survenue lors de l'envoi. Veuillez réessayer.",
      requiredToast: "Veuillez renseigner votre nom, votre email et le poste souhaité.",
      cvFormatToast: "Format de CV non accepté (PDF, DOC ou DOCX uniquement).",
      cvSizeToast: "Le CV dépasse la taille maximale de 5 Mo.",
      confirmedTitle: "Candidature envoyée !",
      confirmedText: "Merci pour votre intérêt pour INEXPONENS. Notre équipe étudiera votre candidature et vous recontactera si votre profil correspond à nos besoins.",
      newApplication: "Envoyer une autre candidature",
    },
  },

  en: {
    nav: [
      { to: "/", label: "Home" },
      { to: "/services", label: "Our Services" },
      { to: "/secteurs", label: "Your Industry" },
      { to: "/equipe", label: "Our Team" },
      { to: "/actualites", label: "News" },
      { to: "/carrieres", label: "Careers" },
      { to: "/contact", label: "Contact" },
    ],
    rdvBtn: "Book a meeting",
    rdvBtnMobile: "Book a meeting",
    brochure: "Download our brochure",
    contactUs: "Contact us",
    requestRdv: "Request an appointment",
    footerDesc: "An accounting firm independent from any network, fully committed to the long-term relationship we build together.",
    footerServices: "Our services",
    footerCabinet: "The firm",
    footerContact: "Contact",
    footerHours: "Mon – Fri: 8:30am – 5:30pm",
    footerRights: "All rights reserved",
    home: {
      cabinetTitle: "The Accounting Firm",
      cabinetP1a: " is an accounting firm independent from any network, based in Conakry. We guarantee our clients impartial opinions and advice, and we are fully committed to the long-term relationship we build together.",
      cabinetP2: "The firm provides its clients in Guinea and abroad with a wide range of services: from accounting and bookkeeping to audit and statutory auditing, as well as strategic advisory and training. We support you from the creation of your company and at every stage of its development.",
      valuesTitle: "Who are we?",
      servicesTitle: "Our Services",
      servicesSubtitle: "Audit and advisory services tailored to your needs.",
      discoverSolutions: "Discover our solutions",
      founderLabel: "The Partner",
      discoverTeam: "Meet our team",
      testimonialsTitle: "What our clients say",
      newsTitle: "News & Insights",
      newsSubtitle: "Tax advice, accounting updates and news from the firm.",
      allNews: "View all news",
      readMore: "Read more",
      ctaTitle: "Together, let's give your business a clear vision",
      ctaText: "Secure your decisions and contribute sustainably to the success of your projects with a trusted partner in Conakry.",
    },
    servicesPage: {
      title: "Our Services",
      subtitle: "Audit, advisory, accounting and training services tailored to your needs.",
      serviceLabel: "Service",
      ctaTitle: "A specific need? Let's talk.",
      ctaText: "Every engagement starts with attentive listening to your challenges.",
    },
    sectorsPage: {
      title: "Your Industry",
      subtitle: "In-depth knowledge of the challenges specific to each sector for relevant support.",
      sectionTitle: "Sector expertise",
      sectionText: "Whatever your field, our team adapts its methods and advice to the specifics of your business.",
      ctaTitle: "Your sector is not listed?",
      ctaText: "Our approach adapts to all activities. Contact us to discuss your challenges.",
    },
    teamPage: {
      title: "Our Team",
      subtitle: "Associates, accountants, legal advisors, auditors and payroll experts at your service.",
      sectionTitle: "A committed team",
      teamText1: "Our dedicated team of associates, accountants, legal advisors, auditors and payroll experts is at your service to support, advise and help you build and grow your business. ",
      teamText2: " is an accounting firm independent from any network: we guarantee our clients impartial opinions and advice, and we are fully committed to the long-term relationship we build together.",
      founderLabel: "The Partner",
      ctaTitle: "Let's meet in Conakry",
      ctaText: "A first no-obligation discussion to understand your needs.",
    },
    contactPage: {
      title: "Contact us",
      subtitle: "Our team is here to answer all your questions.",
      coordsLabel: "Contact details",
      coordsTitle: "Let's talk about your projects",
      address: "Address",
      phone: "Phone",
      email: "Email",
      hours: "Opening hours",
      hoursValue: "Monday – Friday: 8:30am – 5:30pm",
      formTitle: "Send us a message",
      name: "Full name *",
      namePh: "Your name",
      emailField: "Email *",
      emailPh: "you@company.com",
      phoneField: "Phone",
      subject: "Subject of your request",
      subjectPh: "Select a service",
      other: "Other request",
      message: "Message *",
      messagePh: "Describe your need...",
      send: "Send message",
      sending: "Sending...",
      successToast: "Your message has been sent. We will get back to you as soon as possible.",
      errorToast: "An error occurred while sending. Check your email address and try again.",
      requiredToast: "Please fill in the required fields (name, email, message).",
    },
    rdvPage: {
      title: "Book a meeting",
      subtitle: "Book a slot with our team in a few clicks — Monday to Friday.",
      step1: "1. Choose a date",
      step2: "2. Choose a time slot",
      step3: "3. Your details",
      selectDateFirst: "Select a date above first.",
      loadingSlots: "Loading available slots...",
      name: "Full name *",
      namePh: "Your name",
      email: "Email *",
      emailPh: "you@company.com",
      phone: "Phone",
      service: "Service concerned *",
      servicePh: "Select a service",
      other: "Other request",
      notes: "Details (optional)",
      notesPh: "Briefly describe your need...",
      recap: "Summary:",
      at: "at",
      submit: "Confirm request",
      sending: "Sending...",
      successToast: "Your appointment request has been registered!",
      errorToast: "An error occurred. Please try again.",
      requiredName: "Please enter your name and email.",
      requiredService: "Please select a service.",
      requiredSlot: "Please choose a date and a time slot.",
      slotsError: "Unable to load slots for this date.",
      confirmedTitle: "Request registered!",
      confirmedText1: "Your appointment request for the service",
      confirmedText2: "on",
      confirmedText3: "at",
      confirmedText4: "has been sent to our team. We will confirm this slot by email or phone as soon as possible.",
      newRdv: "Book another meeting",
    },
    newsPage: {
      title: "News & Insights",
      subtitle: "Tax advice, accounting updates and news for businesses in Guinea.",
      readMore: "Read more",
      empty: "No articles published yet.",
      back: "Back to news",
      publishedOn: "Published on",
    },
    careersPage: {
      title: "Careers",
      subtitle: "Join a committed team serving Guinean businesses.",
      sectionTitle: "Join our team",
      sectionText: "INEXPONENS is looking for talented people passionate about accounting and advisory: accountants, auditors, legal advisors and payroll experts. We offer a modern, formative and stimulating work environment at the heart of Guinea's economic development. Send us your application!",
      formTitle: "Submit your application",
      name: "Full name *",
      namePh: "Your name",
      email: "Email *",
      emailPh: "you@email.com",
      phone: "Phone",
      position: "Desired position *",
      positionPh: "Select a position",
      positions: ["Accountant", "Auditor", "Legal advisor", "Payroll expert", "Intern", "Other"],
      message: "Cover message",
      messagePh: "Introduce yourself in a few lines...",
      cv: "Your CV (PDF, DOC or DOCX — 5 MB max)",
      cvBtn: "Choose a file",
      cvNone: "No file selected",
      submit: "Send my application",
      sending: "Sending...",
      successToast: "Your application has been sent. We will review it carefully!",
      errorToast: "An error occurred while sending. Please try again.",
      requiredToast: "Please enter your name, email and desired position.",
      cvFormatToast: "CV format not accepted (PDF, DOC or DOCX only).",
      cvSizeToast: "The CV exceeds the maximum size of 5 MB.",
      confirmedTitle: "Application sent!",
      confirmedText: "Thank you for your interest in INEXPONENS. Our team will review your application and contact you if your profile matches our needs.",
      newApplication: "Send another application",
    },
  },
};
